import { Record } from "immutable";
import gql from "graphql-tag";

const Person = new Record({
  clientId: null,
  clientName: null,
  birthDate: null,
  phone: null,
  email: null,
  passportDoc: null,
  passportSer: null,
  passportNum: null,
  passportDate: null,
  passportPlace: null,
  passportCode: null,
  address: null,
  passWord: null,
  phone2: null,
  phone3: null,
  address2: null,
  blockComment: null,
});

const query = gql`
  query searchClients($searchBy: SearchField!, $search: String!) {
    clients(searchBy: $searchBy, search: $search) {
      clientId
      clientName
      birthDate
      phone
      email
      passportDoc
      passportSer
      passportNum
      passportDate
      passportPlace
      passportCode
      address
      passWord
      phone2
      phone3
      address2
      blockComment
    }
  }
`;

export { query };
export default Person;



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/schema/Person.js